import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/imgs/blank-logo.png';
const _withScopeId = n => (_pushScopeId("data-v-51301ac0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ad-softeware__container"
};
const _hoisted_2 = {
  class: "library-center"
};
const _hoisted_3 = {
  class: "library-card"
};
const _hoisted_4 = {
  class: "library-title"
};
const _hoisted_5 = {
  class: "library-box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass(['library-box__text', 'library-box__active'])
}, " 商包广告库 ", -1));
const _hoisted_7 = {
  key: 0,
  class: "ad-table__container"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1,
  class: "brand-green"
};
const _hoisted_10 = {
  key: "1"
};
const _hoisted_11 = {
  class: "library-nobody"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card-icon",
  src: _imports_0,
  style: {
    "width": "230px",
    "height": "225px",
    "margin-top": "60px"
  }
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-tips"
}, "请先在 “我的软件库”添加商包，才能新增广告计划哦～", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Banner = _resolveComponent("Banner");
  const _component_t_button = _resolveComponent("t-button");
  const _component_t_space = _resolveComponent("t-space");
  const _component_t_link = _resolveComponent("t-link");
  const _component_t_table = _resolveComponent("t-table");
  const _component_t_pagination = _resolveComponent("t-pagination");
  const _component_t_content = _resolveComponent("t-content");
  const _component_Footer = _resolveComponent("Footer");
  const _component_t_layout = _resolveComponent("t-layout");
  return _openBlock(), _createBlock(_component_t_layout, {
    style: 'height: 100%'
  }, {
    default: _withCtx(() => [_createVNode(_component_t_content, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Banner), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "library-box__text",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _ctx.goToSoftware && _ctx.goToSoftware(...args))
      }, " 我的软件库 "), _hoisted_6]), _ctx.adSoftwareList.length ? (_openBlock(), _createBlock(_component_t_button, {
        key: 0,
        variant: "outline",
        theme: "primary",
        style: {
          "width": "150px"
        },
        onClick: _ctx.addAdPlane,
        disabled: !_ctx.canAddNewPlane
      }, {
        default: _withCtx(() => [_createTextVNode(" + 新增广告计划 ")]),
        _: 1
      }, 8, ["onClick", "disabled"])) : _createCommentVNode("", true)]), _ctx.adSoftwareList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_t_table, {
        columns: _ctx.columns,
        data: _ctx.adSoftwareList,
        "row-key": "index"
      }, {
        start_time: _withCtx(({
          row: {
            start_time
          }
        }) => [_createElementVNode("p", null, _toDisplayString(_ctx.moment(start_time).format('YYYY-MM-DD')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.moment(start_time).format('HH:mm:ss')), 1)]),
        end_time: _withCtx(({
          row: {
            end_time
          }
        }) => [_createElementVNode("p", null, _toDisplayString(_ctx.moment(end_time).format('YYYY-MM-DD')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.moment(end_time).format('HH:mm:ss')), 1)]),
        plan_state: _withCtx(({
          row: {
            status
          }
        }) => [_createVNode(_component_t_space, null, {
          default: _withCtx(() => [status == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "审核中")) : _createCommentVNode("", true), status == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "已审核")) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)]),
        operator: _withCtx(({
          row: {
            status,
            plan_id
          }
        }) => [_createVNode(_component_t_space, null, {
          default: _withCtx(() => [_createVNode(_component_t_link, {
            hover: "color",
            class: "brand",
            onClick: $event => _ctx.checkEvent(plan_id, status)
          }, {
            default: _withCtx(() => [_createTextVNode("查看")]),
            _: 2
          }, 1032, ["onClick"]), status == 1 ? (_openBlock(), _createBlock(_component_t_link, {
            key: 0,
            hover: "color",
            class: "brand",
            onClick: $event => _ctx.editEvent(plan_id)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)]),
        _: 1
      }, 8, ["columns", "data"]), _createVNode(_component_t_pagination, {
        modelValue: _ctx.page.current,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.page.current = $event),
        total: _ctx.page.total,
        pageSize: 5,
        showPageSize: false,
        totalContent: false
      }, null, 8, ["modelValue", "total"])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_t_button, {
        variant: "outline",
        theme: "primary",
        style: {
          "margin-top": "30px",
          "width": "150px"
        },
        onClick: _ctx.addAdPlane,
        disabled: !_ctx.canAddNewPlane
      }, {
        default: _withCtx(() => [_createTextVNode(" + 新增广告计划 ")]),
        _: 1
      }, 8, ["onClick", "disabled"]), _hoisted_13])]))])])])]),
      _: 1
    }), _createVNode(_component_Footer)]),
    _: 1
  });
}